export default {
  index: 'Home Page',
  logOut: 'Log Out',
  profile: 'Personal Center',
  webcomeBack: 'Welcome',
  noName: 'No name yet'
}
